
export interface GoogleMapsResult {
  formatted_address: string;
  geometry: {
    location: {
      lat: number;
      lng: number;
    };
    viewport?: {
      northeast: { lat: number; lng: number };
      southwest: { lat: number; lng: number };
    };
  };
  place_id: string;
}

const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzGTzTdzei8naUaH5zzdiJZB3353sNsRTSbTXTx1hvFITbW9pkvd4RS7jTEsmuq3Uhd/exec';

export const searchPlace = async (query: string): Promise<GoogleMapsResult[]> => {
  if (!query || query.length < 3) return [];

  try {
    const url = `${APPS_SCRIPT_URL}?direccion=${encodeURIComponent(query)}`;
    const response = await fetch(url);
    const data = await response.json();

    if (data.error) {
      console.error('Google Maps API Error via Apps Script:', data.error);
      return [];
    }

    if (data.status === 'OK' && Array.isArray(data.results)) {
      return data.results;
    }

    return [];
  } catch (error) {
    console.error('Error fetching from Google Maps Apps Script:', error);
    return [];
  }
};
